var PDFBlock = require("./block");
var util = require("./util");
function PDFAbsolute(options, children) {
    options = options || {};
    this._tmpOptions = options;
    PDFBlock.call(this, options, children);
    // TODO: validate the inputs
    this.top = util.getOption(options, "top", null);
    this.left = util.getOption(options, "left", null);
    this.bottom = util.getOption(options, "bottom", null);
    this.right = util.getOption(options, "right", null);
    this.absolute = true;
}
util.inherits(PDFAbsolute, PDFBlock);
util.definePercentageProp(PDFBlock.prototype, "top", function (cursor, pct) { return cursor.height * pct; });
util.definePercentageProp(PDFBlock.prototype, "bottom", function (cursor, pct) { return cursor.height * pct; });
util.definePercentageProp(PDFBlock.prototype, "left", function (cursor, pct) { return cursor.width * pct; });
util.definePercentageProp(PDFBlock.prototype, "right", function (cursor, pct) { return cursor.width * pct; });
PDFAbsolute.prototype.setPositioning = function (cursor) {
    // if (typeof (this.bottom) === 'number') {
    //     if (typeof (this.top) === 'number') this.height = cursor.height - this.top - this.bottom;
    //     else this.top = cursor.height - this.height - this.bottom;
    // }
    // if (typeof (this.right) === 'number') {
    //     if (typeof (this.left) === 'number') this.width = cursor.width - this.left - this.right;
    //     else this.left = cursor.width - this.width - this.right;
    // }
    if (typeof this.top === "number" && typeof this.bottom === "number") {
        this.height = cursor.height - this.top - this.bottom;
    }
    if (typeof this.left === "number" && typeof this.right === "number") {
        this.width = cursor.width - this.left - this.right;
    }
};
function hashCursor(cursor) {
    return [cursor.width, cursor.height];
}
PDFAbsolute.prototype.calc = function (cursor) {
    this.__cursor = cursor;
    if (this.cache.has(hashCursor(cursor)))
        return this.cache.get(hashCursor(cursor));
    this.setPositioning(cursor);
    var newCursor = {
        x: cursor.x + (this.left || 0),
        y: cursor.y + (this.top || 0),
        width: cursor.width,
        height: cursor.height,
        doc: cursor.doc
    };
    var ret = PDFBlock.prototype.calc.call(this, newCursor);
    this.cache.set(hashCursor(cursor), ret);
    return ret;
};
PDFAbsolute.prototype.draw = function (cursor) {
    var metrics = this.calc(cursor);
    var top = typeof this.top === "number" ? this.top : cursor.height - metrics.height - (this.bottom || 0);
    var left = typeof this.left === "number" ? this.left : cursor.width - metrics.width - (this.right || 0);
    var newCursor = {
        x: cursor.x + left,
        y: cursor.y + top,
        width: cursor.width,
        height: cursor.height,
        doc: cursor.doc
    };
    return PDFBlock.prototype.draw.call(this, newCursor);
};
module.exports = PDFAbsolute;
//# sourceMappingURL=module.js.map